
import { onMounted, defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useList } from '@/hooks/use-list';
import { getWebUserAgreementPageApi, postWebUserAgreementStateApi } from '@/api/agreement';
import { DICTIONARY_STATUS_LIST, DICTIONARY_STATUS_ENUM } from './constant';
import { filters } from '@/core/plugins/filter';
import type {
  GetWebUserAgreementPageApiReq as IParams,
  getWebUserAgreementPageApiResListResItem as ListItem,
} from '@/api/agreement/types';
import { usePermissionConfig } from '../../use-permission-config';

export default defineComponent({
  setup() {
    const permissionConfig = usePermissionConfig();
    const router = useRouter();
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<ListItem, IParams>({
      request: {
        api: getWebUserAgreementPageApi,
        params: {
          pageNum: '1',
          pageSize: '20',
        },
      },
    });

    const handleState = async (agreementId: string, state: DICTIONARY_STATUS_ENUM) => {
      await postWebUserAgreementStateApi({
        agreementId,
        state,
      });
      handleSearch();
    };

    const jumpDetail = (query?: { id: string; }) => {
      router.push({
        name: 'SystemConfigAgreementManageDetail',
        query,
      });
    };

    onMounted(() => {
      handleSearch();
    });

    return {
      permissionConfig,
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      filters,
      DICTIONARY_STATUS_LIST,
      DICTIONARY_STATUS_ENUM,
      handleState,
      jumpDetail,
    };
  },
});
